<script>
  let {
    value = $bindable(""),
    options = [["Indifferent", ""], ["Yes", 1], ["No", 0]],
    ...allProps
  } = $props()
</script>

<select class="select" bind:value={value} {...allProps}>
  {#each options as [label, value]}
    <option value={value}>{label}</option>
  {/each}
</select>
